import commonPasswordBlocklist from './commonPasswordBlocklist.json';

export const COMMON_PASSWORD_VALIDATION_ERROR = 'common-password';

export const normalizePasswordForComparison = value => {
  return typeof value === 'string' ? value.toLowerCase().replace(/[^a-z0-9]/g, '') : '';
};

const commonPasswordSet = new Set(
  commonPasswordBlocklist.map(password => normalizePasswordForComparison(password))
);

export const isCommonPassword = value => {
  const normalizedPassword = normalizePasswordForComparison(value);
  return normalizedPassword.length > 0 && commonPasswordSet.has(normalizedPassword);
};

export const createCommonPasswordValidationError = () => ({
  status: 400,
  reason: 'validation-error',
  validationError: COMMON_PASSWORD_VALIDATION_ERROR,
  message:
    'Choose a password that is harder to guess. Avoid common passwords and obvious variations.',
});

export const isCommonPasswordValidationError = error =>
  error?.validationError === COMMON_PASSWORD_VALIDATION_ERROR;
